<template>
  <div class="content">
    <div class="md-layout">
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
        <md-card>
          <md-card-header data-background-color="green">
            <h4 class="title">Subscribes</h4>
            <p class="category">Subscribe list</p>
          </md-card-header>
          <md-card-content v-if="subscribers.length">
            <md-table v-model="subscribers" table-header-color="green">
              <md-table-row slot="md-table-row" slot-scope="{ item }">
                <md-table-cell md-label="Contact Email" >
                  <p class="reservation_table-name">
                    {{item.email}}
                  </p>
                </md-table-cell>
<!--                <md-table-cell md-label="Contact Phone">{{item.phone}}</md-table-cell>-->
                <md-table-cell md-label="Created Date">{{ getDate(item.updated_at) }}</md-table-cell>
<!--                <md-table-cell md-label="Message"><span class="item_message">{{ item.message }}</span></md-table-cell>-->
<!--                <md-table-cell md-label="">-->
<!--                  <md-button class="" @click="openMore(item)">-->
<!--                    Delete-->
<!--                  </md-button>-->
<!--                </md-table-cell>-->
                <md-table-cell md-label="">
                  <span class="cursor_pointer" @click="openDelete(item.id)">
                    <md-icon class="color_red">delete</md-icon>
                  </span>
                </md-table-cell>
              </md-table-row>
            </md-table>
          </md-card-content>
          <md-table>
            <md-table-cell v-if="!subscribers.length"><p class="px-3">No subscribers yet. </p></md-table-cell>
          </md-table>
        </md-card>
      </div>
    </div>
    <!--    del  -->
    <md-dialog :md-active.sync="showDelDialog" class="custom-dialog">
      <md-dialog-title>Delete Subscriber</md-dialog-title>
      <div class="md-layout-item md-small-size-100 md-size-100">
        <h4>Are you sure you want to delete this subscriber?</h4>
        <br>
        <p>This action cannot be undone and the contact details will be permanently removed.</p>
      </div>
      <md-dialog-actions class="my-3">
        <md-button class="md-secondary" @click="showDelDialog = false">Close</md-button>
        <md-button class="md-primary" @click="onConfirmDelete()">Delete</md-button>
      </md-dialog-actions>
    </md-dialog>
    <!--    del  -->

  </div>
</template>

<script>
import {mapActions} from "vuex";
export default {
  name: "AdminSubscribes",
  data() {
    return {
      showDelDialog: false,
      delContactId: null,
      subscribers: [],
      modalData: {}
    }
  },
  created() {
    this.getAllSubscribes()
  },
  methods: {
    ...mapActions(['getSubscribes', 'removeSubscriber']),
    getDate(input) {
      const date = new Date(input);
      const options = { year: 'numeric', month: 'short', day: 'numeric' };
      return date.toLocaleDateString('en-US', options);
    },
    getAllSubscribes() {
      this.getSubscribes()
          .then(res => {
            this.subscribers = res.data.data
          })
    },
    openDelete(id) {
      this.delContactId = id
      this.showDelDialog = true
    },
    onConfirmDelete() {
      this.removeSubscriber(this.delContactId)
          .then(res => {
            if(res.status == 200) {
              this.showDelDialog = !this.showDelDialog
              this.delContactId = null
              this.getAllSubscribes()
            }
            if(res.status == 404) {
              this.delError = res.response.data.error
            }
          })
    },
  }
}
</script>

<style scoped lang="scss">
.item_more {
  text-decoration: underline;
}
.item_message {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
  max-width: 90px;
}
//.md-icon {
//  color: #66bb6a !important;
//}

.color_red {
  color: red !important;
}
</style>
